"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    defaultAppTheme: ()=>defaultAppTheme,
    ThemeProvider: ()=>ThemeProvider,
    useTheme: ()=>useTheme
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const defaultAppTheme = {
    header_icon_link: null,
    text: '#000000',
    highlight_text: '#000000',
    primary: '#128FF9',
    background_primary: '#FFFFFF',
    background_secondary: '#F5F5F5',
    button_primary: '#128FF9',
    button_text: '#FFFFFF',
    card: '#FFFFFF',
    card_text: '#000000',
    card_border_size: null,
    card_border_color: '#128FF9',
    panel: '#FFFFFF',
    panel_text: '#000000',
    nav_background: '#128FF9',
    nav_icon: '#FFFFFF',
    nav_icon_active: '#8ebde6',
    menu_background_primary: '#FFFFFF',
    menu_background_secondary: '#FFFFFF',
    menu_text: '#000000',
    header: '#FFFFFF',
    header_text: '#000000',
    header_icon: '#000000',
    radius_sm: null,
    radius_md: null,
    radius_lg: null,
    field_border_size: null,
    field_background: '#F5F5F5',
    field_border: '#128FF9',
    field_color: '#000000',
    modal: '#FFFFFF',
    modal_text: '#000000',
    modal_border_size: null,
    modal_border_color: '#128FF9',
    footer_length: 6,
    has_title_text: true,
    is_footer_text: true
};
const ThemeContext = /*#__PURE__*/ _react.default.createContext(defaultAppTheme);
const ThemeProvider = ({ children , theme  })=>{
    return /*#__PURE__*/ _react.default.createElement(ThemeContext.Provider, {
        value: theme
    }, children);
};
const useTheme = ()=>(0, _react.useContext)(ThemeContext);
